// ── Passagem Comercial → Operações ──
// Quando um orçamento é ganho, cada projeto nasce «A aguardar passagem»: o comercial deixa o briefing,
// o TL da área nomeia quem fica com o projeto e essa pessoa aceita. Até aceitar, o projeto fica bloqueado
// (fases, calendário e formações) e continua a ser do comercial. Nos eventos com vários serviços,
// cada linha tem o seu responsável e o seu «Aceito», além do coordenador do evento.
import { supabase } from '../supabase';
import { ehEvento } from './eventos';

export const HUB = 'https://hub.workwell.pt';
const JOANA = { email: 'joana.santos@workwell.pt', nome: 'Joana Santos' };
const DINIS = { email: 'dinis.santos@workwell.pt', nome: 'Dinis Santos' };
// Academy é da equipa Mind; Moments é da equipa Vitality
export const TL_AREA = { Mind: JOANA, Academy: JOANA, Vitality: DINIS, Moments: DINIS };
export const ADMINS = [{ email: 'catia.tomas@workwell.pt', nome: 'Cátia Tomás' }, { email: 'tiago.santos@workwell.pt', nome: 'Tiago Santos' }];
export const PRAZO_DIAS_UTEIS = 2;

const low = (x) => String(x || '').trim().toLowerCase();
export const ehAdmin = (email) => ADMINS.some(a => a.email === low(email));
export const AREAS = ['Mind', 'Academy', 'Vitality', 'Moments'];
export const areaDeLinha = (l) => (AREAS.includes(l) ? l : null);
export const areaDeCodigo = (c) => {
  const x = String(c || '').toUpperCase();
  if (x.startsWith('THR')) return 'Mind';
  if (x.startsWith('BEN')) return 'Vitality';
  if (x.startsWith('ACA')) return 'Academy';
  if (x.startsWith('MOM') || x.startsWith('WBG') || x.startsWith('WBA')) return 'Moments';
  return null;
};
export const tlDe = (area) => TL_AREA[area] || ADMINS[0];
export const ehEventoCliente = (p) => !!p && p.project_type === 'Evento';
export const linhasDe = (p) => (Array.isArray(p && p.linhas_faturacao) ? p.linhas_faturacao : []);
export const passagemAberta = (p) => !!p && (p.passagem_estado === 'pendente' || p.passagem_estado === 'falta_info');

// dias úteis (seg–sex) desde uma data
export function diasUteisDesde(isoTs) {
  if (!isoTs) return 0;
  const d = new Date(isoTs); d.setHours(12, 0, 0, 0);
  const h = new Date(); h.setHours(12, 0, 0, 0);
  let n = 0;
  while (d < h) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w > 0 && w < 6) n++; }
  return n;
}
export const atrasada = (p) => p && p.passagem_estado === 'pendente' && diasUteisDesde(p.passagem_pedida_em) >= PRAZO_DIAS_UTEIS;

// motivo do bloqueio (texto) ou null se o projeto pode avançar
export function bloqueio(p) {
  if (!passagemAberta(p)) return null;
  if (p.passagem_estado === 'falta_info')
    return `Falta informação pedida por ${p.passagem_falta_por || 'Operações'} ao comercial`;
  const quem = p.passagem_resp_nome || p.passagem_tl_nome || 'Operações';
  if (ehEventoCliente(p)) {
    const falta = [];
    if (!p.passagem_resp_email) falta.push(`${p.passagem_tl_nome || 'o TL'} nomear o coordenador do evento`);
    else if (!p.coordenador_aceite_em) falta.push(`${p.passagem_resp_nome} aceitar a coordenação do evento`);
    const ls = linhasDe(p);
    const semResp = ls.filter(l => !l.resp_email).length, porAceitar = ls.filter(l => l.resp_email && !l.aceite_em).length;
    if (semResp) falta.push(`${semResp} serviço(s) sem responsável`);
    if (porAceitar) falta.push(`${porAceitar} serviço(s) por aceitar`);
    return 'A aguardar passagem: ' + (falta.join(' · ') || 'confirmação');
  }
  return p.passagem_resp_email ? `A aguardar que ${quem} aceite a passagem` : `A aguardar que ${p.passagem_tl_nome || 'o TL'} nomeie o responsável`;
}

export const podeNomear = (p, email) => ehAdmin(email) || low(email) === low(p && p.passagem_tl_email);
export const podeAceitar = (p, email) => podeNomear(p, email) || low(email) === low(p && p.passagem_resp_email);
export const podeNomearLinha = (l, email) => ehAdmin(email) || low(email) === low(tlDe(l.area || areaDeCodigo(l.codigo)).email);
export const podeAceitarLinha = (l, email) => podeNomearLinha(l, email) || low(email) === low(l.resp_email);

// ── avisos ──
const caixa = (titulo, corpo, link, botao) => `<div style="font-family:Helvetica,Arial,sans-serif;max-width:560px;margin:0 auto;padding:24px;color:#1A1A2E">
<div style="background:#691FB1;border-radius:12px 12px 0 0;padding:16px 22px"><span style="color:#fff;font-size:16px;font-weight:700">${titulo}</span></div>
<div style="border:1px solid #E4DEFA;border-top:none;border-radius:0 0 12px 12px;padding:22px;font-size:14px;line-height:1.6">${corpo}
${link ? `<p style="margin:18px 0 0"><a href="${link}" style="background:#691FB1;color:#fff;text-decoration:none;padding:10px 18px;border-radius:8px;font-weight:600;display:inline-block">${botao || 'Abrir no HUB'}</a></p>` : ''}
</div></div>`;
const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
async function email(to, toName, subject, titulo, corpo, link, botao) {
  if (!to) return;
  try { await supabase.functions.invoke('Send-email', { body: { to, toName: toName || '', fromName: 'Workwell - HUB', subject, html: caixa(titulo, corpo, link, botao) } }); } catch (_) { /* o aviso é uma ajuda */ }
}
const hoje = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
async function tarefa(projectId, pessoa, texto, link) {
  if (!pessoa || !pessoa.email) return;
  try {
    await supabase.from('project_tarefas').insert({ project_id: projectId, fase_id: null, texto, data_lembrete: hoje(), autor_email: null, autor_nome: 'HUB',
      responsavel_email: pessoa.email, responsavel_nome: pessoa.nome || pessoa.email, link, notificada: true });   // o email sai já, não no resumo da manhã
  } catch (_) { /* idem */ }
}
async function fecharTarefas(projectId, filtro) {
  try {
    let q = supabase.from('project_tarefas').update({ feita: true }).eq('project_id', projectId).ilike('texto', 'Passagem%').not('feita', 'is', true);
    if (filtro) q = q.ilike('texto', `%${filtro}%`);
    await q;
  } catch (_) { /* idem */ }
}
const linkP = (p) => `${HUB}/projetos/${p.id}`;

function resumoBriefing(b) {
  if (!b) return '';
  const l = [['Contexto', b.contexto], ['Contactos', b.contactos], ['Acessos', b.acessos], ['Datas-chave', b.datas_chave], ['O que conta como «pronto»', b.pronto], ['Notas internas', b.notas]]
    .filter(x => String(x[1] || '').trim());
  return l.length ? `<table style="font-size:13px;border-collapse:collapse;margin:10px 0">${l.map(([k, v]) => `<tr><td style="padding:3px 12px 3px 0;color:#8888AA;vertical-align:top;white-space:nowrap">${k}</td><td style="padding:3px 0;white-space:pre-wrap">${esc(v)}</td></tr>`).join('')}</table>` : '';
}

async function gravar(id, campos) {
  const { data, error } = await supabase.from('projects').update({ ...campos, updated_at: new Date().toISOString() }).eq('id', id).select('*').single();
  if (error) throw new Error(error.message);
  return data;
}

// ── início: chamado quando o orçamento passa a ganho, para cada projeto criado ──
export async function iniciarPassagem(projectId, briefing) {
  const { data: p } = await supabase.from('projects').select('*').eq('id', projectId).maybeSingle();
  if (!p || p.is_mae) return null;
  const agora = new Date().toISOString();
  // as notas internas do briefing ficam também nas Notas internas do projeto
  if (briefing && String(briefing.notas || '').trim()) {
    try { await supabase.from('project_notes').insert({ project_id: p.id, tipo: 'nota', texto: String(briefing.notas).trim(), autor: briefing.por || p.commercial_name || null }); } catch (_) { /* idem */ }
  }
  // inscrições nos Wellbeing Games / Awards: ficam com o responsável da edição, sem passagem
  if (ehEvento(p.project_type))
    return gravar(p.id, { passagem_estado: 'aceite', passagem_aceite_em: agora, passagem_aceite_por: `Automático (${p.project_type})`, passagem_briefing: briefing || null });
  const area = areaDeLinha(p.business_area) || areaDeCodigo(p.servico_codigo) || (ehEventoCliente(p) ? 'Moments' : null);
  const tl = tlDe(area);
  const linhas = linhasDe(p).map(l => ({ ...l, area: l.area || areaDeCodigo(l.codigo) || area }));
  const novo = await gravar(p.id, {
    passagem_estado: 'pendente', passagem_area: area, passagem_tl_email: tl.email, passagem_tl_nome: tl.nome,
    passagem_resp_email: null, passagem_resp_nome: null, passagem_briefing: briefing || null, passagem_pedida_em: agora,
    passagem_falta_info: null, passagem_falta_por: null, passagem_falta_em: null, passagem_aceite_em: null, passagem_aceite_por: null,
    coordenador_aceite_em: null,
    ...(linhas.length ? { linhas_faturacao: linhas } : {}),
  });
  const oQue = ehEventoCliente(p) ? 'nomear o coordenador do evento' : 'nomear o responsável';
  await tarefa(p.id, tl, `Passagem: ${oQue} de «${p.name}» (vendido por ${p.commercial_name || 'Comercial'})`, `/projetos/${p.id}`);
  await email(tl.email, tl.nome, `Passagem para aceitar — ${p.name}`, 'Passagem para as Operações',
    `<p style="margin:0 0 10px">Olá ${esc(tl.nome.split(' ')[0])},</p><p style="margin:0 0 10px">O projeto <b>${esc(p.name)}</b> foi ganho por ${esc(p.commercial_name || 'Comercial')} e passa para a tua área (${esc(area || '—')}). Falta ${oQue} — até alguém aceitar, o projeto fica bloqueado.</p>${resumoBriefing(briefing)}<p style="margin:10px 0 0;color:#8888AA;font-size:12.5px">Prazo: ${PRAZO_DIAS_UTEIS} dias úteis. Depois disso o HUB avisa o comercial e a administração.</p>`,
    linkP(p), 'Abrir o projeto');
  // eventos: cada TL das outras áreas tem de nomear quem faz o seu serviço
  if (ehEventoCliente(p)) {
    const outros = {};
    linhas.forEach(l => { const t = tlDe(l.area); if (t.email !== tl.email) (outros[t.email] = outros[t.email] || { t, ls: [] }).ls.push(l); });
    for (const { t, ls } of Object.values(outros)) {
      await tarefa(p.id, t, `Passagem: nomear o responsável de ${ls.map(l => l.descricao || l.codigo).join(', ')} no evento «${p.name}»`, `/projetos/${p.id}`);
      await email(t.email, t.nome, `Evento com um serviço da tua área — ${p.name}`, 'Serviço num evento',
        `<p style="margin:0 0 10px">O evento <b>${esc(p.name)}</b> inclui serviços da tua área: <b>${esc(ls.map(l => l.descricao || l.codigo).join(', '))}</b>. Nomeia quem fica responsável por cada um — o evento não avança enquanto houver serviços sem dono.</p>${resumoBriefing(briefing)}`,
        linkP(p), 'Abrir o evento');
    }
  }
  return novo;
}

async function concluirSePronto(p, autor) {
  if (ehEventoCliente(p)) {
    const ls = linhasDe(p);
    if (!p.coordenador_aceite_em || ls.some(l => !l.aceite_em)) return p;
  }
  const resp = { email: p.passagem_resp_email || autor.email, nome: p.passagem_resp_nome || autor.nome };
  const novo = await gravar(p.id, { passagem_estado: 'aceite', passagem_aceite_em: new Date().toISOString(), passagem_aceite_por: autor.nome || autor.email,
    passagem_resp_email: resp.email, passagem_resp_nome: resp.nome, owner_email: resp.email, owner_name: resp.nome });
  await fecharTarefas(p.id);
  await email(p.commercial_email, p.commercial_name, `Passagem aceite — ${p.name}`, 'Passagem aceite',
    `<p style="margin:0">O projeto <b>${esc(p.name)}</b> foi aceite pelas Operações. Responsável: <b>${esc(resp.nome)}</b>.</p>`, linkP(p));
  return novo;
}

export async function nomear(p, pessoa, autor) {
  // a pessoa nomeada passa logo a «Responsável Operações» do projeto (um só sítio para preencher); o 🔒 mantém-se até aceitar
  const novo = await gravar(p.id, { passagem_resp_email: pessoa.email, passagem_resp_nome: pessoa.nome, coordenador_aceite_em: null,
    owner_email: pessoa.email, owner_name: pessoa.nome });
  await fecharTarefas(p.id, 'nomear o');
  if (low(pessoa.email) !== low(autor.email)) {
    const oQue = ehEventoCliente(p) ? 'coordenar o evento' : 'ficar com o projeto';
    await tarefa(p.id, pessoa, `Passagem: ler o briefing e aceitar ${oQue} «${p.name}»`, `/projetos/${p.id}`);
    await email(pessoa.email, pessoa.nome, `Tens um projeto para aceitar — ${p.name}`, 'Projeto para aceitar',
      `<p style="margin:0 0 10px">${esc(autor.nome)} nomeou-te para ${oQue} <b>${esc(p.name)}</b>. Lê o briefing e carrega em <b>Aceito</b> — ou em <b>Falta informação</b> se precisares de algo do comercial.</p>${resumoBriefing(p.passagem_briefing)}`,
      linkP(p), 'Abrir o projeto');
  }
  return novo;
}

// passagem já aceite: o TL ou a administração ainda podem trocar o responsável (ex.: ficou o TL por engano)
export async function mudarResponsavel(p, pessoa, autor) {
  const novo = await gravar(p.id, { passagem_resp_email: pessoa.email, passagem_resp_nome: pessoa.nome, owner_email: pessoa.email, owner_name: pessoa.nome });
  if (low(pessoa.email) !== low(autor.email)) {
    await tarefa(p.id, pessoa, `Ficas responsável pelo projeto «${p.name}»: ler o briefing`, `/projetos/${p.id}`);
    await email(pessoa.email, pessoa.nome, `Ficas responsável por ${p.name}`, 'Novo projeto teu',
      `<p style="margin:0 0 10px">${esc(autor.nome)} passou-te a responsabilidade do projeto <b>${esc(p.name)}</b>.</p>${resumoBriefing(p.passagem_briefing)}`,
      linkP(p), 'Abrir o projeto');
  }
  return novo;
}

export async function aceitar(p, autor) {
  if (ehEventoCliente(p)) {
    const base = p.passagem_resp_email ? p : await gravar(p.id, { passagem_resp_email: autor.email, passagem_resp_nome: autor.nome, owner_email: autor.email, owner_name: autor.nome });
    const novo = await gravar(p.id, { coordenador_aceite_em: new Date().toISOString() });
    await fecharTarefas(p.id, 'coordenar');
    return concluirSePronto({ ...base, ...novo }, autor);
  }
  const base = p.passagem_resp_email ? p : { ...p, passagem_resp_email: autor.email, passagem_resp_nome: autor.nome };
  return concluirSePronto(base, autor);
}

export async function nomearLinha(p, idx, pessoa, autor) {
  const ls = linhasDe(p).map((l, i) => i === idx ? { ...l, resp_email: pessoa.email, resp_nome: pessoa.nome, aceite_em: null, aceite_por: null } : l);
  const novo = await gravar(p.id, { linhas_faturacao: ls });
  const l = ls[idx];
  if (low(pessoa.email) !== low(autor.email)) {
    await tarefa(p.id, pessoa, `Passagem: aceitar ${l.descricao || l.codigo} no evento «${p.name}»`, `/projetos/${p.id}`);
    await email(pessoa.email, pessoa.nome, `Serviço para aceitar num evento — ${p.name}`, 'Serviço para aceitar',
      `<p style="margin:0 0 10px">${esc(autor.nome)} nomeou-te responsável por <b>${esc(l.descricao || l.codigo)}</b> no evento <b>${esc(p.name)}</b>. Abre o evento e carrega em <b>Aceito</b> nessa linha.</p>${resumoBriefing(p.passagem_briefing)}`,
      linkP(p), 'Abrir o evento');
  }
  return novo;
}

export async function aceitarLinha(p, idx, autor) {
  const ls = linhasDe(p).map((l, i) => i === idx ? { ...l, resp_email: l.resp_email || autor.email, resp_nome: l.resp_nome || autor.nome, aceite_em: new Date().toISOString(), aceite_por: autor.nome } : l);
  const novo = await gravar(p.id, { linhas_faturacao: ls });
  const l = ls[idx];
  await fecharTarefas(p.id, l.descricao || l.codigo);
  return concluirSePronto(novo, autor);
}

export async function pedirInfo(p, texto, autor) {
  const novo = await gravar(p.id, { passagem_estado: 'falta_info', passagem_falta_info: texto, passagem_falta_por: autor.nome, passagem_falta_em: new Date().toISOString() });
  const com = { email: p.commercial_email, nome: p.commercial_name };
  await tarefa(p.id, com, `Passagem: responder ao pedido de informação de ${autor.nome} sobre «${p.name}»`, `/projetos/${p.id}`);
  await email(com.email, com.nome, `Falta informação para a passagem — ${p.name}`, 'Pedido de informação',
    `<p style="margin:0 0 10px">${esc(autor.nome)} precisa de informação para aceitar <b>${esc(p.name)}</b>:</p><blockquote style="margin:0 0 10px;padding:8px 12px;background:#F7F5FC;border-left:3px solid #691FB1;white-space:pre-wrap">${esc(texto)}</blockquote><p style="margin:0">Responde no próprio projeto, em «Responder». Até lá o projeto continua bloqueado e contigo.</p>`,
    linkP(p), 'Responder no HUB');
  return novo;
}

export async function responderInfo(p, texto, autor) {
  const b = p.passagem_briefing || {};
  const respostas = [...(Array.isArray(b.respostas) ? b.respostas : []), { em: new Date().toISOString(), pergunta: p.passagem_falta_info, pergunta_por: p.passagem_falta_por, resposta: texto, por: autor.nome }];
  const novo = await gravar(p.id, { passagem_estado: 'pendente', passagem_briefing: { ...b, respostas }, passagem_falta_info: null, passagem_falta_por: null, passagem_falta_em: null,
    passagem_pedida_em: new Date().toISOString() });   // o prazo volta a contar a partir da resposta
  await fecharTarefas(p.id, 'responder ao pedido');
  const dest = p.passagem_resp_email ? { email: p.passagem_resp_email, nome: p.passagem_resp_nome } : { email: p.passagem_tl_email, nome: p.passagem_tl_nome };
  await email(dest.email, dest.nome, `Resposta do comercial — ${p.name}`, 'Informação recebida',
    `<p style="margin:0 0 10px">${esc(autor.nome)} respondeu ao pedido de informação sobre <b>${esc(p.name)}</b>:</p><blockquote style="margin:0 0 10px;padding:8px 12px;background:#F7F5FC;border-left:3px solid #691FB1;white-space:pre-wrap">${esc(texto)}</blockquote><p style="margin:0">O prazo de ${PRAZO_DIAS_UTEIS} dias úteis volta a contar a partir de hoje.</p>`,
    linkP(p), 'Abrir o projeto');
  return novo;
}

export async function editarBriefing(p, briefing) {
  return gravar(p.id, { passagem_briefing: { ...(p.passagem_briefing || {}), ...briefing } });
}

// para uso nas outras páginas (Calendário, Formações): devolve o motivo do bloqueio de um projeto pelo id
export async function bloqueioDoProjeto(projectId) {
  if (!projectId) return null;
  try {
    const { data: p } = await supabase.from('projects').select('id,name,project_type,passagem_estado,passagem_resp_email,passagem_resp_nome,passagem_tl_nome,passagem_falta_por,coordenador_aceite_em,linhas_faturacao').eq('id', projectId).maybeSingle();
    const m = bloqueio(p);
    return m ? `«${p.name}»: ${m}.\n\nO projeto só avança depois de as Operações aceitarem a passagem (no próprio projeto).` : null;
  } catch (_) { return null; }   // colunas ainda não criadas: não bloqueia
}
